var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgWav = function SvgWav(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F37834",
    fillRule: "evenodd",
    d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 0v4a2 2 0 0 0 2 2h4z",
    opacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 8,
    x: 2,
    y: 13,
    fill: "#F7F8FA",
    rx: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F37834",
    d: "M4.144 19 3 15h1.05l.593 2.621h.033L5.354 15h.856l.678 2.627h.032L7.515 15h1.049L7.42 19h-.915l-.709-2.426h-.03L5.057 19zM9.92 19H8.898l1.327-4h1.265l1.327 4h-1.022l-.923-2.992h-.03zm-.137-1.574h2.135v.734H9.783zM14.145 15l.88 2.93h.032l.88-2.93H17l-1.327 4h-1.265l-1.326-4z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWav);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;